import { c as _c } from "react/compiler-runtime";
import { useTranslation, Trans } from 'react-i18next';
import React from 'react';
import Image from 'next/image';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
export function Ceo() {
  const $ = _c(26);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["mallpay"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("ceo.name");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="mb-8 lg:mb-0 lg:flex-[0_0_28.5rem]"><Image src="/images/sections/forJournalists/ceo.png" alt={t1} width="456" height="342" /></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Link to={LINKS().aboutDeferredPayment} analyticsParam="mallpayAboutDeferredPayment" testId="mallpayAboutDeferredPayment" className="text-white!" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = <p className="mb-4 text-center text-base font-bold text-white lg:mb-6 lg:text-left lg:text-xl"><Trans t={t} i18nKey="ceo.text">{t3}</Trans></p>;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("ceo.name");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <span className="text-xs font-semibold lg:text-base">{t5}</span>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <br />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("ceo.job");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <span className="text-xs lg:text-base">{t8}</span>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6 || $[18] !== t9) {
    t10 = <p className="text-center text-white lg:text-left">{t6}{t7}{t9}</p>;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t4) {
    t11 = <div>{t4}{t10}</div>;
    $[20] = t10;
    $[21] = t4;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t2) {
    t12 = <div className="mx-auto mb-14 max-w-[21.5rem] rounded-3xl bg-blue-500 px-4 pt-4 pb-8 lg:mb-20 lg:flex lg:max-w-[73rem] lg:items-center lg:gap-20 lg:rounded-[2.5rem] lg:py-8 lg:pr-20 lg:pl-8">{t2}{t11}</div>;
    $[23] = t11;
    $[24] = t2;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}